import {createI18n} from "vue-i18n";
import translation from "@/locale/translation";

const i18n = createI18n({
    legacy: false,
    locale: 'EN',
    fallbackLocale: 'EN',
    messages: translation,
});

export default i18n;